import React from 'react';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'danger' | 'freeze' | 'unfreeze';
  size?: 'small' | 'medium' | 'large';
  icon?: string;
  loading?: boolean;
  children?: React.ReactNode;
  as?: 'button' | 'a';
  href?: string;
  target?: string;
  rel?: string;
}

export function Button({
  variant = 'primary',
  size = 'medium',
  icon,
  loading = false,
  children,
  className = '',
  disabled,
  as = 'button',
  href,
  target,
  rel,
  ...props
}: ButtonProps) {
  const baseClass = 'btn';
  const variantClass = `btn-${variant}`;
  const sizeClass = size === 'large' ? 'btn-large' : size === 'small' ? 'btn-small' : '';
  const classes = [baseClass, variantClass, sizeClass, className].filter(Boolean).join(' ');

  const content = (
    <>
      {loading && <i className="fa-solid fa-spinner fa-spin"></i>}
      {!loading && icon && <i className={icon}></i>}
      {children && <span>{children}</span>}
    </>
  );

  if (as === 'a' && href) {
    return (
      <a
        href={href}
        className={classes}
        target={target}
        rel={rel}
        {...(props as React.AnchorHTMLAttributes<HTMLAnchorElement>)}
      >
        {content}
      </a>
    );
  }

  return (
    <button className={classes} disabled={disabled || loading} {...props}>
      {content}
    </button>
  );
}
